export class TeamGroups {
    _id: String;
    name: String;
    active: boolean;
    consultants: any = [];

    loadUserDataForGrid(r: any) {
        this._id = r._id ? r._id : '';
        this.name = r.name ? r.name : '';
        this.active = r.active ? r.active : false;
        this.consultants = r.consultants ? r.consultants: '';
    }
}



// WEBPACK FOOTER //
// ./src/app/models/teamGroups.model.ts